// Mascot avatar — cartoon Charles. Drop a PNG/SVG at
// `console/public/charles-mascot.png` and it'll be picked up here.
// Falls back to a stylized purple monogram if the file isn't there.

interface MascotAvatarProps {
  size?: number;
  className?: string;
}

export function MascotAvatar({ size = 32, className = "" }: MascotAvatarProps) {
  return (
    <div
      className={`relative shrink-0 overflow-hidden rounded-full bg-gradient-to-br from-accent-500 to-accent-700 ring-2 ring-accent-500/40 ${className}`}
      style={{ width: size, height: size }}
    >
      {/* Background layer: monogram fallback (only visible if image fails) */}
      <span
        className="absolute inset-0 flex items-center justify-center text-white"
        style={{ fontSize: size * 0.45, fontWeight: 700, letterSpacing: "-0.05em" }}
      >
        C
      </span>
      {/* Foreground: actual mascot. If it 404s we hide it, revealing the C. */}
      <img
        src="/charles-mascot.png"
        alt="Charles"
        className="absolute inset-0 h-full w-full object-cover"
        onError={(e) => {
          (e.currentTarget as HTMLImageElement).style.display = "none";
        }}
      />
    </div>
  );
}
